import axios from "axios";
import { useSelector } from "react-redux";
import ReactGA from "react-ga";
import { getAccessToken } from "./apiTokenHandler";

// Fire-and-forget session-detail logger for the microsite journey. Reads the
// correlation reference (urlRef) from portal state, mirrors the existing ReactGA
// behaviour, and durably records the event via POST /api/memberportalsessiondetail.
// It never blocks the UI and swallows all errors.
export const useSessionDetailLog = () => {
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );

  const logSessionDetail = (
    event: string,
    extra?: { pageNumber?: number }
  ) => {
    const reference = portalSessionMeta?.urlRef;

    try {
      ReactGA.event({
        category: "Microsite Journey",
        action: event,
        label: reference || "",
      });
    } catch (e) {
      // ignore analytics errors
    }

    try {
      const accessToken = getAccessToken();
      const payload = {
        Reference: reference,
        Event: event,
        PageNumber: extra?.pageNumber ?? null,
        ClientTimeUtc: new Date().toISOString(),
      };

      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}/api/memberportalsessiondetail`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken || null}`,
            },
          }
        )
        .catch(() => {
          // fire-and-forget: never disrupt the flow
        });
    } catch (e) {
      // ignore logging errors
    }
  };

  return { logSessionDetail };
};

export default useSessionDetailLog;
